import salesDashBoard from '../views/sales/dashboard/dashboard'
import salesDashBoard2 from '../views/sales/dashboard2/dashboard'
import salesDashBoard3 from '../views/sales/dashboard3/dashboard'
import salesDashBoard2Close from '../views/sales/dashboard2/component/closed'

export default [
  {
    path: '/sales/old/dashboard',
    name: 'sales-dashbard',
    component: salesDashBoard
  },
  {
    path: '/sales/old/dashboard2',
    name: 'sales-dashbard2',
    component: salesDashBoard2
  },
  {
    path: '/sales/dashboard',
    name: 'sales-dashbard3',
    component: salesDashBoard3
  },
  {
    path: '/sales/old/dashboard2Close',
    name: 'sales-dashboard2Close',
    component: salesDashBoard2Close
  },
]


// WEBPACK FOOTER //
// ./src/router/salesdashboard.js